import { DEFAULTS } from "./defaults.js";
import { FILE_UPLOAD_TYPE } from "./types.js";
import { nodeViewRenderers } from "./viewer/nodeViewRenderers.js";
const pluginFileUpload = (config) => {
  return {
    config: { ...DEFAULTS.configViewer, ...config },
    type: FILE_UPLOAD_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginFileUpload
};
//# sourceMappingURL=viewer.js.map
